<template>
  <pwa-layout subtitle="ESPACE PRO" :show-back="false">
    <template #header-action>
      <button class="pwa-icon-btn" @click="$router.push('/pwa/settings')">
        <span class="mdi mdi-cog-outline" style="font-size:22px;color:var(--pwa-text)"></span>
      </button>
    </template>

    <div class="pwa-profile">

      <!-- Company Avatar + Info -->
      <div class="pwa-company-header">
        <div class="pwa-company-avatar">
          <span class="mdi mdi-truck"></span>
          <span class="pwa-company-check"><span class="mdi mdi-check-circle"></span></span>
        </div>
        <div class="pwa-company-name">{{ company.name || 'Entreprise' }}</div>
        <div class="pwa-company-badges">
          <span class="pwa-badge-id">ID: {{ company.slug || '-' }}</span>
          <span v-if="company.is_premium" class="pwa-badge-premium">Compte Premium</span>
        </div>
      </div>

      <!-- Gestionnaire -->
      <div class="pwa-section-label">GESTIONNAIRE</div>
      <div class="pwa-card">
        <div class="pwa-list-item">
          <div class="pwa-list-avatar">
            <span class="mdi mdi-account"></span>
          </div>
          <div class="pwa-list-info">
            <div class="pwa-list-title">{{ userName }}</div>
            <div class="pwa-list-sub">{{ userRole }}</div>
          </div>
        </div>
      </div>

      <!-- Notifications -->
      <div class="pwa-section-label">NOTIFICATIONS</div>
      <div class="pwa-card">
        <div class="pwa-list-item">
          <div class="pwa-list-icon pwa-list-icon--dark">
            <span class="mdi mdi-bell-outline"></span>
          </div>
          <div class="pwa-list-info">
            <div class="pwa-list-title">Alertes Transactions</div>
            <div class="pwa-list-sub">Notif. immédiate par transaction</div>
          </div>
          <label class="pwa-toggle">
            <input type="checkbox" v-model="notifAlerts" />
            <span class="pwa-toggle-track"></span>
          </label>
        </div>
        <div class="pwa-divider"></div>
        <div class="pwa-list-item">
          <div class="pwa-list-icon" style="background:#F0F4F8;">
            <span class="mdi mdi-car-outline" style="color:var(--pwa-muted)"></span>
          </div>
          <div class="pwa-list-info">
            <div class="pwa-list-title">Mouvements Flotte</div>
            <div class="pwa-list-sub">Rapports hebdomadaires</div>
          </div>
          <label class="pwa-toggle">
            <input type="checkbox" v-model="notifFleet" />
            <span class="pwa-toggle-track"></span>
          </label>
        </div>
      </div>

      <!-- Déconnexion -->
      <button class="pwa-logout-btn" @click="logout">
        <span class="mdi mdi-logout" style="margin-right:8px"></span>
        Se déconnecter
      </button>

      <div class="pwa-version">Gwassou B2B v2.4.0 · Build 2024</div>
    </div>
  </pwa-layout>
</template>

<script>
import PwaLayout from './PwaLayout.vue'
import AccountService from '@/services/AccountService'

export default {
  name: 'PwaProfile',
  components: { PwaLayout },
  data() {
    return {
      notifAlerts: true,
      notifFleet: false,
    }
  },
  computed: {
    company() {
      return this.$store.getters['app/getCompany'] || {}
    },
    user() {
      return this.$store.state.app.user || {}
    },
    userName() {
      return `${this.user.first_name || ''} ${this.user.last_name || ''}`.trim() || this.user.username || '-'
    },
    userRole() {
      if (this.$store.getters['app/isCompanyOwner']) return 'Administrateur Flotte'
      return 'Membre'
    },
  },
  methods: {
    async logout() {
      try {
        await AccountService.logout()
      } catch (e) { /* ignore */ }
      this.$store.commit('app/clearSession')
      this.$router.push('/signin')
    },
  },
}
</script>

<style scoped>
.pwa-profile { padding: 0 16px 32px; }

/* Company header */
.pwa-company-header {
  display: flex; flex-direction: column; align-items: center;
  padding: 24px 0 16px;
}
.pwa-company-avatar {
  width: 80px; height: 80px; border-radius: 20px;
  background: linear-gradient(135deg, #1976D2, #42A5F5);
  display: flex; align-items: center; justify-content: center;
  font-size: 36px; color: white; position: relative; margin-bottom: 12px;
}
.pwa-company-check {
  position: absolute; bottom: -6px; right: -6px;
  width: 24px; height: 24px; border-radius: 50%;
  background: var(--pwa-success); color: white;
  display: flex; align-items: center; justify-content: center;
  font-size: 14px; border: 2px solid var(--pwa-bg);
}
.pwa-company-name { font-size: 20px; font-weight: 700; color: var(--pwa-text); margin-bottom: 8px; text-align: center; }
.pwa-company-badges { display: flex; gap: 8px; flex-wrap: wrap; justify-content: center; }
.pwa-badge-id {
  font-size: 12px; color: var(--pwa-muted); background: var(--pwa-white);
  border: 1px solid #E0E6ED; border-radius: 20px; padding: 3px 10px;
}
.pwa-badge-premium {
  font-size: 12px; color: var(--pwa-accent); border: 1px solid var(--pwa-accent);
  border-radius: 20px; padding: 3px 10px;
}

/* Section label */
.pwa-section-label {
  font-size: 11px; font-weight: 600; color: var(--pwa-muted);
  letter-spacing: 1px; margin: 20px 0 8px; text-transform: uppercase;
}

/* Card */
.pwa-card { background: var(--pwa-white); border-radius: var(--pwa-card-radius); overflow: hidden; }
.pwa-divider { height: 1px; background: #F0F4F8; margin: 0 16px; }

/* List item */
.pwa-list-item {
  display: flex; align-items: center; gap: 12px;
  padding: 14px 16px;
}
.pwa-list-item--link { cursor: pointer; }
.pwa-list-item--link:active { background: #F8FAFC; }
.pwa-list-avatar {
  width: 40px; height: 40px; border-radius: 50%;
  background: #F0F4F8; display: flex; align-items: center; justify-content: center;
  font-size: 18px; color: var(--pwa-muted); flex-shrink: 0;
}
.pwa-list-icon {
  width: 36px; height: 36px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; flex-shrink: 0;
}
.pwa-list-icon--blue { background: #E3F2FD; color: #1976D2; }
.pwa-list-icon--purple { background: #F3E5F5; color: #7B1FA2; }
.pwa-list-icon--orange { background: #FFF3E0; color: #E65100; }
.pwa-list-icon--dark { background: #E8F0FE; color: var(--pwa-dark); }
.pwa-list-info { flex: 1; min-width: 0; }
.pwa-list-title { font-size: 14px; font-weight: 500; color: var(--pwa-text); }
.pwa-list-sub { font-size: 12px; color: var(--pwa-muted); margin-top: 1px; }
.pwa-list-action { font-size: 13px; font-weight: 600; color: var(--pwa-accent); border: none; background: none; cursor: pointer; }
.pwa-list-chevron { font-size: 20px; color: var(--pwa-muted); }

/* Toggle */
.pwa-toggle { position: relative; width: 44px; height: 24px; flex-shrink: 0; }
.pwa-toggle input { opacity: 0; width: 0; height: 0; }
.pwa-toggle-track {
  position: absolute; inset: 0; border-radius: 12px;
  background: #D1D9E6; transition: background 0.2s; cursor: pointer;
}
.pwa-toggle-track::after {
  content: ''; position: absolute;
  width: 18px; height: 18px; border-radius: 50%;
  background: white; top: 3px; left: 3px;
  transition: transform 0.2s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}
.pwa-toggle input:checked + .pwa-toggle-track { background: var(--pwa-accent); }
.pwa-toggle input:checked + .pwa-toggle-track::after { transform: translateX(20px); }

/* Logout */
.pwa-logout-btn {
  width: 100%; margin-top: 24px; padding: 14px;
  border-radius: var(--pwa-card-radius); border: 1.5px solid #FFCDD2;
  background: var(--pwa-white); color: var(--pwa-error);
  font-size: 15px; font-weight: 600; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
}

.pwa-version { text-align: center; margin-top: 16px; font-size: 11px; color: var(--pwa-muted); }
</style>
